<template>
    <div class="select-box" ref="selectBox">
        <!-- Trigger Button -->
        <button @click="toggleDropdown"
                :class="[triggerClass || 'btn-v2', { 'dropdown-active': isSelectOpen }]">
            <template v-if="$scopedSlots.trigger">
                <slot name="trigger" :selectedOption="selectedOption" :isOpen="isSelectOpen"/>
            </template>
            <template v-else>
                <span v-if="selectedOption">
                    <slot name="triggerIcon"/>
                    <img v-if="selectedOption.icon" :src="selectedOption.icon" width="16" height="16" alt=""/>
                    {{ selectedOption.label }}
                </span>
                <span v-else>{{ translate.home.please_select }}</span>
            </template>
            <icon-component :icon="fa_chevron_right_bold()"
                            width="10px"
                            height="10px"
                            class="arrow"
                            :class="{ active: isSelectOpen }"/>
        </button>

        <!-- Dropdown Content -->
        <div v-show="isSelectOpen" @click.self="closeDropdown"
             :class="dropdownPosition === 'top' ? 'select-box--dropdown-top' : 'select-box--dropdown'">
            <div class="select-box--dropdown-container">
                <header class="select-box--dropdown-header">
                    <button @click="closeDropdown" class="btn-v2 btn-v2-outline-grey mb-2">{{
                            translate.home.back
                        }}
                    </button>
                    <span class="title" v-if="title">{{ title }}</span>
                    <span class="description" v-if="description">{{ description }}</span>
                </header>
                <section class="select-box--dropdown-content">
                    <div class="form-select-v2" v-for="(opt, index) in options" :key="opt.value">

                        <template v-if="type === 'link'">
                            <a :href="opt.link" @click.prevent="onSelectionChange(opt.value , true)"
                               class="cursor-pointer" :class="[{'checked' : value === opt.value}, optionClass]">
                                <img v-if="opt.icon" :src="opt.icon" width="16" height="16" alt=""/>
                                <span>{{ opt.label }}</span>
                            </a>
                        </template>

                        <template v-else>
                            <input
                                :id="`${name}-${index}`"
                                :type="type"
                                :value="opt.value"
                                v-model="modelValue"
                                @change="onSelectionChange(opt.value)"/>

                            <label :for="`${name}-${index}`" :class="optionClass">
                                <img v-if="opt.icon" :src="opt.icon" width="16" height="16" alt=""/>
                                <span>{{ opt.label }}</span>
                            </label>
                        </template>
                    </div>
                </section>
            </div>
        </div>
    </div>
</template>

<script>
import IconComponent from "@/components/global/IconComponent.vue";
import {fa_chevron_right_bold} from "@/core/constants/icons";
import {mapState} from "vuex";

export default {
    components: {IconComponent},
    props: {
        options: {
            type: Array,
            required: true,
        },
        type: {
            type: String,
            default: "radio",
        },
        name: {
            type: String,
            required: true,
        },
        title: String,
        description: String,
        triggerClass: {
            type: [String, Array, Object],
            default: () => ''
        },
        value: [String, Number, Boolean],
        dropdownPosition: {
            type: [String],
            default: 'bottom'
        },
        optionClass: {
            type: [String, Array, Object],
            default: () => ''
        },
    },
    data() {
        return {
            isSelectOpen: false,
        };
    },
    computed: {
        ...mapState(["translate"]),
        modelValue: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit("input", val);
            },
        },
        selectedOption() {
            return this.options.find((option) => option.value === this.value);
        }
    },
    methods: {
        fa_chevron_right_bold,
        toggleDropdown() {
            this.isSelectOpen = !this.isSelectOpen;
        },
        closeDropdown() {
            this.isSelectOpen = false;
        },
        handleClickOutside(event) {
            if (!this.$refs.selectBox.contains(event.target)) {
                this.closeDropdown();
            }
        },
        onSelectionChange(value, updateValue = false) {
            if (updateValue) {
                this.modelValue = value;
            }

            this.closeDropdown();
            this.$emit("change", value);
        },
    },
    mounted() {
        document.addEventListener("click", this.handleClickOutside);
    },
    beforeDestroy() {
        document.removeEventListener("click", this.handleClickOutside);
    },
};
</script>
